// Chat
const Listchat = () => import('@/views/chat')

export default {
    path: 'chat',
    redirect: '/chat',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'chat',
            component: Listchat,
            meta: {
                link: 'chat',
                // breadcrumb: [
                //     { title: 'Chat', active: true },
                // ],
                // pageTitle: 'Chat'
            }
        }
    ]
}